import { Typography, IconButton, Icon, Box, Stack } from '@ace-clublabs/shared-component-library';
import { ProductType } from '../../application/models/NewJoinSessionData';
import { PriceInfoCard } from './PriceInfoCard';

interface IAddOn {
  onAdd?: () => void;
  showPrice?: boolean;
  price?: number | { min: number; max: number };
  discountedPrice?: number;
  priceSuffix?: string;
  priceRange?: { min: number; max: number };
  text: string;
  icon: string;
  type: ProductType | 'associate' | 'family-upgrade';
  isPriceCartLoading?: boolean;
  isUpdating?: boolean;
}

export const AddOn = ({
  showPrice = true,
  text,
  price,
  discountedPrice,
  priceSuffix,
  onAdd,
  type,
  isPriceCartLoading,
  isUpdating,
}: IAddOn) => {
  const containerClassName = `add-${type}-container add-benefit-container`;
  const addClassName = `add-${type}`;
  const isAssociate = type === 'associate';

  return (
    <Stack
      className={containerClassName}
      direction="row"
      sx={{
        marginTop: '1rem',
        cursor: isPriceCartLoading ? '' : 'pointer',
        background: '#FFF',
        border: isPriceCartLoading ? `1.5px dashed #CACDCE` : `1.5px dashed #1976d2`,
        borderRadius: '0.5rem',
      }}
      onClick={isPriceCartLoading ? undefined : onAdd}
    >
      <Stack className="add-benefit" direction="row" justifyContent="flex-start" alignItems="center" gap="0.5rem">
        <Box sx={{ fontSize: '1.5rem' }} className={'addon-icon'}>
          <Icon
            aria-label={addClassName}
            sx={{ fontSize: '1.25rem', padding: '0 !important', color: isPriceCartLoading ? '#CACDCE' : '#1976d2' }}
            className={addClassName}
            iconName="plus-regular"
          />
        </Box>
        <Typography
          data-di-mask={isAssociate ? 'true' : 'false'}
          className="add-on-text qm-mask"
          variant="b1Medium"
          sx={{ color: isPriceCartLoading ? '#CACDCE' : '#016BCD' }}
        >
          {text}
        </Typography>
      </Stack>
      <Stack className="add-benefit-details" direction="row" justifyContent="center" alignItems="center" gap="0.5rem">
        {showPrice &&
          price !== undefined &&
          (typeof price === 'number' ? (
            <PriceInfoCard
              originalPrice={price}
              priceAfterDiscount={discountedPrice}
              priceSuffix={priceSuffix}
              className={`${type}-price`}
              isPriceCartLoading={isPriceCartLoading}
              isUpdating={isUpdating}
            />
          ) : (
            <PriceInfoCard
              priceRange={price}
              priceAfterDiscount={discountedPrice}
              priceSuffix={priceSuffix}
              className={`${type}-price`}
              isPriceCartLoading={isPriceCartLoading}
              isUpdating={isUpdating}
            />
          ))}
      </Stack>
    </Stack>
  );
};
